import { getUUID } from 'utils/uuid';

export const ShortcutOverlayConfig = [
  { id: getUUID(), keycap: 'K', label: 'Search', usePrefix: true },
  { id: getUUID(), keycap: '1-9', label: 'Jump to tabs', usePrefix: true },
  { id: getUUID(), keycap: '/', label: 'Actions', usePrefix: false },
  { id: getUUID(), keycap: '?', label: 'Shortcuts', usePrefix: true },
];
